import { NAV_TRACKING_LABELS } from '~/javascripts/tracking/constants';

// Keys are mirrored in app/helpers/sidebar_helper.rb, which resolves the active item
export const SIDEBAR_ITEM_KEYS = Object.freeze({
  subscriptions: 'subscriptions',
  invoices: 'invoices',
  billingAccounts: 'billing_accounts',
});

export const SIDEBAR_ITEMS = Object.freeze([
  {
    key: SIDEBAR_ITEM_KEYS.subscriptions,
    title: 'Subscriptions & purchases',
    path: '/',
    trackingLabel: NAV_TRACKING_LABELS.subscription,
  },
  {
    key: SIDEBAR_ITEM_KEYS.invoices,
    title: 'Invoices',
    path: '/invoices',
    trackingLabel: NAV_TRACKING_LABELS.invoices,
  },
  {
    key: SIDEBAR_ITEM_KEYS.billingAccounts,
    title: 'Billing account settings',
    path: '/billing_accounts',
    trackingLabel: NAV_TRACKING_LABELS.billingSettings,
  },
]);
